import _ from 'lodash';
import Vue from 'vue';

import MenuApi from '@/store/api/menu';
import PageApi from '@/store/api/page';

// initial state
const state = {
    page: {},
    header: {},
};

// getters
const getters = {
    sections: (state) => {
        let sections = _.get(state, 'page.sections') || [];
        return _.cloneDeep(sections).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0));
    },
    headerNews: (state) => state.header,
    view: (state) => state.page.view,
    reference: (state) => state.page.reference
};

// mutations
const mutations = {
    addPageToState(state, page) {
        state.page = page;
    },
    updateCategoryPostTeasersLoading(state, { s, value }) {
        Vue.set(state.page.sections[s].teasers, 'loading', value);
    },
    updateCategoryPostTeasersLoadingIntoHeader(state, { value }) {
        Vue.set(state.header.teasers, 'loading', value);
    },
    insertTeasers(state, { s, teasers }) {
        Vue.set(state.page.sections[s], 'teasers', teasers);
    },
    updateTeaserFilter(state, { s, filter }) {
        const i = _.findIndex(state.page.sections[s].teasers.pagination.filters, { key: filter.key });
        Vue.set(state.page.sections[s].teasers.pagination.filters, i, filter);
    },
    insertCategoryPostTeasersIntoHeader(state, { teasers }) {
        Vue.set(state.header, 'teasers', teasers);
    },
};

// actions
const actions = {
    fetchMenuItem({ commit }, { path, cms }) {
        return MenuApi.fetchItem(path, cms);
        // .then(data => commit('addPageToState', data.page))
    },
    fetchCategoryPostTeasers({ commit }, payload) {
        return PageApi.fetchPagesPaginated(payload);
    },
    fetchCategoryPost({ commit }, payload) {
        return PageApi.fetchPage(payload);
    },
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations,
};
